// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"6f6d758d","453":"5d8ccced"}[chunkId] + ".chunk.js";
};